import { isPlatformBrowser } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { APP_ID, Inject, NgModule, PLATFORM_ID } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { FormsModule } from '@angular/forms';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { FirebaseModule } from 'src/shared/firebase/firebase.module';
import { TokenInterceptor } from 'src/shared/interceptors/token.interceptor';
import { SharedModule } from 'src/shared/shared.module';
import initLanguageProvider from 'src/shared/translate/providers/init-language';
import { environment } from '../environments/environment';
import { ErrorInterceptor } from '../shared/interceptors/error.interceptor';
import { NgSwCheckForUpdateService } from '../shared/services/service-worker/ngsw-check-for-update.service';
import { NgSwLogUpdateService } from '../shared/services/service-worker/ngsw-log-update.service';
import { NgSwPromptUpdateService } from '../shared/services/service-worker/ngsw-prompt-update.service';
import { BrowserStorage } from '../shared/storages/browser.storage';
import { STORAGE } from '../shared/storages/storages.inject';
import { TranslateBrowserModule } from '../shared/translate/translate-browser.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

@NgModule({
  imports: [
    BrowserModule.withServerTransition({ appId: 'favie-tech-angular' }),
    TransferHttpCacheModule,
    TranslateBrowserModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    // AngularFireAnalyticsModule, // Turn on GG Ana
    // Enable service worker.
    ServiceWorkerModule.register('./ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
    FirebaseModule,
    SharedModule,
    BrowserAnimationsModule,
    MatLegacyDialogModule
  ],
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  providers: [
    NgSwLogUpdateService,
    NgSwPromptUpdateService,
    NgSwCheckForUpdateService,
    { provide: STORAGE, useClass: BrowserStorage },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    initLanguageProvider,
  ],
})
export class AppModule {
  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    @Inject(APP_ID) appId: string
  ) {
    const platform = isPlatformBrowser(platformId)
      ? 'in the browser'
      : 'on the server';
    console.log(`Running ${platform} with appId=${appId}`);
  }
}
